@use "ui/styles/colors";
@use "ui/styles/fonts";
@use "ui/styles/fontStyles";
@use "ui/styles/sizes";

.wrapper {
  position: relative;
  margin-inline-end: sizes.$s4;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: sizes.$s4;
  color: var(--text-color);
  @include fontStyles.subtitle2-bold;

  .icon {
    position: relative;
    display: flex;
    padding: sizes.$s3;
    border-radius: sizes.$s3;
  }

  &.testing .icon {
    color: colors.$greenDark;
    background-color: colors.$greenLightest;
  }

  &.training .icon {
    color: colors.$purple;
    background-color: colors.$purpleLightest;
  }
}

.navButton {
  padding: sizes.$s4; // to match TopNavButton padding
}

.link {
  font-weight: fonts.$book;
}
